import script from "./GenericModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericModal.vue?vue&type=script&setup=true&lang=js"

import "./GenericModal.vue?vue&type=style&index=0&id=d5b4e46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5b4e46c"]])

export default __exports__